import i18n from "i18n";

const prepTypeMapping = {
  BAS: i18n.t("reception"),
  REQ: i18n.t("orders.klasses.REQ"),
  ADJ: i18n.t("inventory.purchase"),
  SALE: i18n.t("orders.types.SALE"),
  PUR: i18n.t("by.purchase"),
  REF: i18n.t("client.returned"),
  PRO: i18n.t("orders.klasses.PRO"),
};

export default prepTypeMapping;
